import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=8d5b125c&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d5b125c')) {
      api.createRecord('8d5b125c', component.options)
    } else {
      api.reload('8d5b125c', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=8d5b125c&", function () {
      api.rerender('8d5b125c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hfYJKuXGU71W/JS/comp/starrating.vue"
export default component.exports